<template>
<div class="main h5-wrap">
  <h3 class="title">
    {{$store.getters.getCompanyInfo.name}}
    <br>
    疫情防控系统
  </h3>
  <div class="login transprent-form-h5">
    <el-form :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm">
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="ruleForm.phone" placeholder="请输入手机号">
        </el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="code">
        <el-input v-model="ruleForm.code" maxlength="6" placeholder="请输验证码">
        </el-input>
        <div v-if="hasSendCode" class="verifycode time">
          {{time}} s
        </div>
        <div v-else class="verifycode" @click="getVerifyCode('ruleForm')">获取验证码</div>
      </el-form-item>
    </el-form>
  </div>
  <div class="footer">
    <p>请输入您的手机号码，登录或注册您的账号</p>
    <el-button class="button" type="primary" :loading="loading" @click="submitForm('ruleForm')">登录/注册</el-button>
  </div>
</div>
</template>
<script>
  export default {
    name: 'Login',
    data() {
      return {
        organization_id: '',
        hasSendCode: false,
        loading: false,
        timer: 0,
        time: 60,
        ruleForm: {
          phone: '',
          code: '',
          type: 'user_login'
        },
        rules: {
          phone: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            { pattern: /^\d{11}$/, message: '手机号码格式错误', trigger: 'blur' }
          ],
          code: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
            { pattern: /^\d{6}$/, message: '验证码码格式错误', trigger: 'blur' }
          ]
        }
      }
    },
    mounted() {
      this.organization_id = +this.$store.getters.getCompanyInfo.organization_id
    },
    methods: {
      getVerifyCode(formName) {
        this.$refs[formName].validateField('phone', (valid) => {
          if (!valid) {
            this.hasSendCode = true;
            this.startTimer();
            this.axios.get(`/auth/verification/obtain?type=user_login&phone=${this.ruleForm.phone}`).then(r => {
              this.loading = false;
              if(r.data.code !== 200){
                this.clearTimer()
                this.$message({
                  type: 'error',
                  message: r.data.msg,
                  customClass: 'message-style'
                });
              }
            }).catch( err => {
              this.clearTimer()
              console.log(err)
              this.loading = false
              this.$message({
                message: err || '服务异常',
                type: 'error',
                customClass: 'message-style'
              })
            })
            
          }
        })
      },
      clearTimer() {
        clearTimeout(this.timer)
        this.hasSendCode = false;
        this.time = 60;
      },
      startTimer() {
        if(this.time <= 0) {
          this.clearTimer()
        } else {
          this.timer = setTimeout(()=>{
            this.time--;
            this.startTimer()
          }, 1000)
        }
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log(this.ruleForm)
            this.loading = true;
            let condition = JSON.parse(JSON.stringify(this.ruleForm));
            condition.organization_id = this.organization_id
            this.axios.post('/auth/app/login', condition).then(r => {
              if(r.data.code === 200){
                let data = r.data.data;
                this.axios.defaults.headers.common['Authorization'] = data.token;
                this.$localStorage.set('UserInfo', JSON.stringify(data))
                this.getPersonInfo(data)
              } else {
                this.loading = false;
                this.$message({
                  type: 'error',
                  message: r.data.msg,
                  customClass: 'message-style'
                });
              }
            }).catch( err => {
              console.log(err)
              this.$message({
                type: 'error',
                message: err,
                customClass: 'message-style'
              });
              this.loading = false
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      getPersonInfo(datas) {
        this.axios({
          method: 'get',
          url: `person/`,
          params: {
            person_id: datas.user_id,
            organization_id: this.organization_id
          }
        }).then(r => {
          this.loading = false;
          if(r.data.code === 200){
            let data = r.data.data;
            if(data.id_number){
              localStorage.setItem('personInfo', JSON.stringify(data))
              this.$router.replace('/h5/temperature')
            } else {
              let query = {
                phone: this.ruleForm.phone,
                face_toggle: datas.face_feature,
                org_type: datas.org_type
              }
              this.$router.replace({path: '/h5/personform', query: query})
            }
          } else {
            this.$message({
              type: 'error',
              message: r.data.msg,
              customClass: 'message-style'
            });
          }
        }).catch(err =>{
          this.loading = false;
          this.$message({
            type: 'error',
            message: err,
            customClass: 'message-style'
          });
          console.log(err)
        })
      }
    }
  }
</script>
<style scoped lang="scss">
.main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: .4rem .18rem 0;
  background: url('https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/bg.png') no-repeat center top / 100% 100%;
  h3 {
    margin: 0;
    font-weight: bold;
    font-size: .36rem;
    text-align: center;
    font-style: italic;
    color: #fff;
    letter-spacing: 0;
  }
  .title-img {
    width: 100%;
    margin: .15rem 0 .5rem;
  }
}
.login {
  flex-grow: 1;
  margin-top: .4rem;
}
.verifycode {
  position: absolute;
  right: 0;
  top: 0;
  background: #7C5FCA;
  border-radius: 2px;
  color: #fff;
  width: 1rem;
  text-align: center;
  font-size: .13rem;
  height: .3rem;
  line-height: .3rem;
}
.footer {
  margin-top: .4rem;
  p {
    margin: 0;
    font-size: .13rem;
    text-align: center;
    color: rgba(255,255,255,.7)
  }
  .button {
    width: 100%;
    height: .5rem;
    margin: .17rem 0 .2rem;
  }
}
</style>
